var _circle, _path, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevicesYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 26.7087C10.5 24.5022 10.5 23.399 10.8051 22.5105C11.3688 20.8692 12.6583 19.5798 14.2996 19.0161C15.1881 18.7109 16.2913 18.7109 18.4978 18.7109H19.6446C21.4135 18.7109 22.298 18.7109 23.0321 18.8647C25.8469 19.4541 28.0461 21.6533 28.6355 24.4681C28.7893 25.2022 28.7893 26.0867 28.7893 27.8556C28.7893 29.6245 28.7893 30.5089 28.6355 31.2431C28.0461 34.0578 25.8469 36.257 23.0321 36.8465C22.298 37.0002 21.4135 37.0002 19.6446 37.0002C17.8757 37.0002 16.9913 37.0002 16.2572 36.8465C13.4424 36.257 11.2432 34.0578 10.6537 31.2431C10.5 30.5089 10.5 29.6245 10.5 27.8556V26.7087Z",
    fill: "#E5B910"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0257,
    cy: 25.7503,
    r: 2.58621,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.2153 14.8648C25.7489 14.7085 25.252 14.9592 25.1048 15.427C24.962 15.8939 25.224 16.3999 25.6897 16.5555C26.9868 16.9901 28.2366 17.9324 29.2106 19.2104C30.1841 20.4875 30.7621 21.9432 30.8373 23.309C30.8639 23.7994 31.2824 24.1862 31.7712 24.1716C31.953 24.1649 32.1248 24.1038 32.2669 23.9954C32.4961 23.8207 32.6223 23.5423 32.6068 23.2503C32.512 21.5259 31.8028 19.7126 30.6081 18.1452C29.4135 16.5778 27.853 15.4134 26.2153 14.8648Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M26.8594 10.7209C26.3952 10.5641 25.8954 10.8145 25.7496 11.2824C25.6068 11.7493 25.8688 12.2554 26.3338 12.4116C28.5275 13.1464 30.6374 14.7335 32.2733 16.8798C33.9098 19.0268 34.8809 21.482 35.008 23.792C35.0359 24.2826 35.4538 24.6685 35.9427 24.654C36.1245 24.6473 36.2955 24.5867 36.4376 24.4784C36.6668 24.3037 36.7938 24.0247 36.7775 23.7333C36.6317 21.064 35.5285 18.2519 33.6708 15.8146C31.8143 13.3789 29.3945 11.569 26.8594 10.7209Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesYellow);
export default __webpack_public_path__ + "static/media/devices-yellow.1870778bbc591c896284044801ade87c.svg";
export { ForwardRef as ReactComponent };